import {LocalColumnDefinition, LocalColumnDefinitionsAsArray, SortPredicates} from "mars-modules";

export const AUDIT_COLUMNS = {
  assetAuditFieldName:new LocalColumnDefinition(
    'assetAuditFieldName', SortPredicates.Natural(item => item.auditType)
  ), auditOldValue:new LocalColumnDefinition(
    'auditOldValue', SortPredicates.Natural(item => item.oldValue)
  ), auditNewValue:new LocalColumnDefinition(
    'auditNewValue', SortPredicates.Natural(item => item.newValue)
  ), userName:new LocalColumnDefinition(
    'userName', SortPredicates.Natural(item => item.adminUserLogin)
  ), createdDate:new LocalColumnDefinition(
    'createdDate', SortPredicates.Natural(item => item.createdDate)
  ), auditNotes:new LocalColumnDefinition(
    'auditNotes', SortPredicates.Natural(item => item.notes)
  )
};

export const AUDIT_COLUMNS_AS_ARRAY = LocalColumnDefinitionsAsArray(AUDIT_COLUMNS);
